import Styles from '../style.module.scss';
import {
  Radio,
  Input,
  Button,
  Checkbox,
  Form,
  Row,
  Col,
  message,
  Space,
} from 'antd';
import { useState } from 'react';
import { useRouter } from 'next/router';
import request from '../../../utils/request/next-request';
import SuggestHeader from '../../../components/suggestion/suggestHeader';
import Agreement from '../../../components/commonComponents/agreement';
import Success from '../../../components/commonComponents/success';
import { getConsultTaskOptions } from '../../../services/common';
import { defaultConsultOptions } from '@/utils/config';
import { typeMap } from '../../../utils/config';
import { useUserAgentInfo } from '../../../context/user-agent';
import MobileConsult from '../../../components/fromComponents/consult/MobileConsult';
import { phoneNumberValidator } from '../../../utils/common';

export const Contact = ({ required = false }) => (
  <Space>
    <Form.Item
      label="联系方式："
      name="phoneNum"
      rules={[
        {
          required,
          validator: phoneNumberValidator(required),
        },
      ]}
    >
      <Input
        placeholder="请输入电话号码"
        maxLength={11}
        style={{ width: '377px' }}
      />
    </Form.Item>
    <Form.Item
      label={<div>&nbsp;</div>}
      name="email"
      validateTrigger="onChange"
      rules={[
        {
          validator: (_, value) => {
            const re = new RegExp(
              /^[A-Za-z0-9]+([_\.][A-Za-z0-9]+)*@([A-Za-z0-9\-]+\.)+[A-Za-z]{2,6}$/
            );
            if (value && !re.test(value)) {
              return Promise.reject(new Error('请输入有效邮箱'));
            } else {
              return Promise.resolve();
            }
          },
        },
      ]}
    >
      <Input placeholder="请输入邮箱（非必填）" style={{ width: '391px' }} />
    </Form.Item>
  </Space>
);

export const getServerSideProps = async (context) => {
  try {
    const res = await getConsultTaskOptions();
    return {
      props: {
        sectorMap: res[1].fieldItemModels,
        bizMap: res[2].fieldItemModels,
      },
    };
  } catch (err) {
    return {
      props: {
        sectorMap: defaultConsultOptions[1].fieldItemModels,
        bizMap: defaultConsultOptions[2].fieldItemModels,
      },
    };
  }
};

export default function Consult({ sectorMap, bizMap }) {
  const { isMobile } = useUserAgentInfo();
  const { query } = useRouter();
  const [agree, setAgree] = useState<boolean>();
  const [success, setSuccess] = useState<boolean>(false);

  const suggestions = {
    titleText:
      typeMap[(query.type as string).split('-')[0]] || typeMap['business'],
    titleDesc: '填写您的需求，我们将安排专家与您建立联系',
  };

  const handleSubmit = async (values) => {
    delete values.agreement;
    const res = await request({
      url: `${process.env.NEXT_PUBLIC_API_BASE_URL}/consult`,
      method: 'post',
      data: {
        type: query.type,
        ...values,
      },
    });
    if (res && res.code === 0) {
      setSuccess(true);
      return true;
    } else {
      message.error('出错了！');
      return false;
    }
  };

  return (
    <>
      {isMobile ? (
        <MobileConsult
          suggestions={{ ...suggestions }}
          sectorMap={sectorMap}
          onCreate={handleSubmit}
          bizMap={bizMap}
        />
      ) : (
        <div className={Styles.container}>
          <div className={Styles.wrapper}>
            {success ? (
              <Success text={'您的建议已收到，我们会尽快安排专家与您联系'} />
            ) : (
              <>
                <SuggestHeader {...suggestions} />
                <Form
                  name="basic"
                  initialValues={{ remember: true }}
                  autoComplete="off"
                  layout="vertical"
                  onFinish={(values) => handleSubmit(values)}
                >
                  <Row gutter={12}>
                    <Col flex={1}>
                      <Form.Item
                        label="联系人："
                        name="contactUser"
                        rules={[
                          { required: true, message: '请输入联系人姓名' },
                        ]}
                      >
                        <Input placeholder="请输入联系人姓名" maxLength={20} />
                      </Form.Item>
                    </Col>
                    <Col flex={1}>
                      <Form.Item
                        label="公司名称："
                        name="company"
                        rules={[{ required: true, message: '请输入公司全称' }]}
                      >
                        <Input placeholder="请输入公司全称" maxLength={50} />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Contact required />
                  <Form.Item
                    label="所在行业："
                    name="industry"
                    rules={[{ required: true, message: '请选择所在行业' }]}
                  >
                    <Radio.Group>
                      {sectorMap.map((s) => (
                        <Radio value={s.itemValue} key={s.itemValue}>
                          {s.itemName}
                        </Radio>
                      ))}
                    </Radio.Group>
                  </Form.Item>
                  <Form.Item
                    label="业务类型："
                    name="businessType"
                    rules={[{ required: true, message: '请选择业务类型' }]}
                  >
                    <Checkbox.Group>
                      <Row gutter={[16, 8]}>
                        {bizMap.map((b) => (
                          <Col key={b.itemValue}>
                            <Checkbox value={b.itemValue}>
                              {b.itemName}
                            </Checkbox>
                          </Col>
                        ))}
                      </Row>
                    </Checkbox.Group>
                  </Form.Item>
                  <Form.Item
                    label="咨询问题："
                    name="question"
                    rules={[{ required: true, message: '请填写咨询问题' }]}
                  >
                    <Input.TextArea
                      placeholder="请详细填写您的建议内容，以便我们定位与改进"
                      showCount
                      maxLength={200}
                      className={Styles['text-area']}
                    />
                  </Form.Item>
                  <Form.Item
                    name="agreement"
                    rules={[
                      {
                        validator: () => {
                          return agree
                            ? Promise.resolve()
                            : Promise.reject(new Error('请同意服务条款'));
                        },
                      },
                    ]}
                  >
                    <Agreement onChange={(isChecked) => setAgree(isChecked)} />
                  </Form.Item>
                  <Form.Item>
                    <Button
                      type="primary"
                      htmlType="submit"
                      className={Styles['submit-btn']}
                    >
                      提交
                    </Button>
                  </Form.Item>
                </Form>
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
}
